import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

// Define the initial state
const initialState = {
  city: [],
  status: 'idle', // 'idle' | 'loading' | 'succeeded' | 'failed'
  error: null,
};

// Async thunk for fetching city
export const fetchCity = createAsyncThunk(
  'city/fetchCity',
  async (_, { getState, rejectWithValue }) => {
    try {
      const state = getState(); // Access Redux state
      const token = state?.auth?.access_token; // Adjust this path if needed

      const response = await axios.get('https://nanosoft.technology/outlaw/api/countries/1/cities', {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
console.log(response.data.data.data);

      return response.data.data.data; // Return city data
    } catch (error) {
      console.error('API Error:', error.response || error.message);
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Create the slice
const citySlice = createSlice({
  name: 'city',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCity.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchCity.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.city = action.payload;
      })
      .addCase(fetchCity.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload || action.error.message;
      });
  },
});

export default citySlice.reducer;
